const DB_NAME = 'es-shop-cart'
const STORE = 'esLocalStore'
const BASE_KEY = 'ES_SHOP_CART'

const cartKey = () => {
  try {
    const saved = JSON.parse(localStorage.getItem('vuex') || '{}')
    const usercode = saved.userInfo && saved.userInfo.usercode
    if (usercode) return `${BASE_KEY}_${usercode}`
  } catch (_) {}
  return BASE_KEY
}

const openDb = () => new Promise((resolve, reject) => {
  const request = indexedDB.open(DB_NAME, 1)
  request.onupgradeneeded = () => {
    const store = request.result.createObjectStore(STORE, { keyPath: 'id', autoIncrement: true })
    store.createIndex('key', 'key', { unique: false })
    store.createIndex('value', 'value', { unique: false })
  }
  request.onsuccess = () => resolve(request.result)
  request.onerror = () => reject(request.error)
})

const withStore = async (mode, run) => {
  const db = await openDb()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE, mode)
    const request = run(transaction.objectStore(STORE))
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
    transaction.oncomplete = () => db.close()
  })
}

export const readCart = async () => {
  const record = await withStore('readonly', store => store.index('key').get(cartKey()))
  if (!record) return []
  try { return JSON.parse(record.value) || [] } catch (_) { return [] }
}

export const writeCart = async items => {
  const key = cartKey()
  const current = await withStore('readonly', store => store.index('key').get(key))
  return withStore('readwrite', store => store.put({ ...(current || {}), key, value: JSON.stringify(items) }))
}
